import { create } from 'zustand';

import { ICheckoutPaymentForm } from '../schemas';

export type ICheckoutStatePaymentForm = ICheckoutPaymentForm;

interface ICheckoutState {
  paymentForm: ICheckoutStatePaymentForm;
  setPaymentForm: (CheckoutState: ICheckoutStatePaymentForm) => void;
}

export const usePaymentState = create<ICheckoutState>(set => {
  return {
    paymentForm: sessionStorage.getItem('paymentForm')
      ? JSON.parse(sessionStorage.getItem('paymentForm')!)
      : ({} as ICheckoutStatePaymentForm),
    setPaymentForm(newPaymentForm: ICheckoutStatePaymentForm) {
      set({ paymentForm: newPaymentForm });
      sessionStorage.setItem('paymentForm', JSON.stringify(newPaymentForm));
    },
  };
});
